export default __webpack_public_path__ + "static/media/driver.933fd6fc.svg";